module.exports = __webpack_public_path__ + "static/media/ico_plus.853a8772.svg";